import  { CARGAR_AJUSTE_PLAN_PAGO } from './actionTypes';
import { get_FechaLocalActual } from '../../funciones_globales/utils';
import global_axios from '../../funciones_globales/interaccionapi';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA, INICIALIZAR_FORM } from '../generales/actionTypes';


export const cargar_AjustePlanPago = (importacion) => {
	return (dispatch) => {

		let config_request = {
			method: 'GET',
			url: '/importaciones/' + importacion + '/ajusteplanpago',
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)			
		.then( response => {
			
			dispatch({
				type: CARGAR_AJUSTE_PLAN_PAGO,
				data: response.data	
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar ajuste de importación', mensaje: msgError}
			});
		});
	}
}


export const cargar_ValoresIniciales = () => {
	return (dispatch) => {					
		let fecha = get_FechaLocalActual();
		let motivo = '01';
		let tipo_ajuste = '1';
		dispatch({
			type: INICIALIZAR_FORM,
			data: {	fecha: fecha,
					motivo: motivo,
					tipo_ajuste: tipo_ajuste
				  }			
		})
	}
}